import cloneDeep from 'lodash/cloneDeep';

export const getList = (state) => state.list

export const getMetaList = (state) => {
  const list = cloneDeep(state.metaList);

  return list.map(item => {
    item.item_type = 'meta';

    return item;
  });
}
